import { StyleSheet } from 'react-native';
import { DESKTOP_COLORS, DESKTOP_CONSTANTS } from '@/constants/admin';
import { COLORS } from '@/constants/residents';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: DESKTOP_COLORS.TABLE.BACKGROUND,
  },
  tableHeader: {
    // Styles from DESKTOP_STYLES.tableHeader
  },
  headerScrollView: {
    flex: 1,
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: '100%',
    width: '100%',
  },
  headerCell: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    minHeight: DESKTOP_CONSTANTS.TABLE_HEADER_HEIGHT,
  },
  headerText: {
    fontWeight: '600',
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  sortIndicator: {
    marginLeft: 4,
  },
  sortIndicatorText: {
    fontSize: 12,
    lineHeight: 12,
  },
  tableBody: {
    flex: 1,
    minHeight: 0,
  },
  tableRow: {
    // Styles from DESKTOP_STYLES.tableRow
  },
  selectedRow: {
    backgroundColor: DESKTOP_COLORS.TABLE.ROW_SELECTED,
  },
  rowScrollView: {
    flex: 1,
  },
  rowContent: {
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: '100%',
    width: '100%',
  },
  cell: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: DESKTOP_CONSTANTS.TABLE_ROW_HEIGHT,
  },
  cellText: {
    fontSize: 14,
  },
  arrayCellContainer: {
    width: '100%',
    maxHeight: 72,
  },
  arrayCellScroll: {
    width: '100%',
  },
  checkbox: {
    width: 20,
    height: 20,
    borderWidth: 1,
    borderColor: DESKTOP_COLORS.TABLE.BORDER,
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
  },
  paginationContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: DESKTOP_COLORS.TABLE.BORDER,
    backgroundColor: DESKTOP_COLORS.TABLE.HEADER_BACKGROUND,
  },
  paginationText: {
    fontSize: 14,
  },
  paginationLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  paginationButtons: {
    flexDirection: 'row',
    gap: 8,
  },
  rowsPerPageContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  rowsPerPageLabel: {
    fontSize: 14,
  },
  rowsPerPageOptions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  rowsPerPageOption: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderWidth: 1,
    borderColor: DESKTOP_COLORS.TABLE.BORDER,
    borderRadius: 4,
    backgroundColor: DESKTOP_COLORS.TABLE.BACKGROUND,
  },
  rowsPerPageOptionSelected: {
    borderColor: COLORS.BUTTON_PRIMARY,
    backgroundColor: `${DESKTOP_COLORS.BUTTON.PRIMARY_BACKGROUND}10`,
  },
  rowsPerPageOptionText: {
    fontSize: 13,
  },
  rowsPerPageOptionTextSelected: {
    color: DESKTOP_COLORS.TABLE.TEXT,
    fontWeight: '600',
  },
  paginationButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 4,
    gap: 4,
  },
  paginationButtonDisabled: {
    opacity: 0.5,
  },
  paginationButtonText: {
    fontSize: 14,
    fontWeight: '500',
  },
  paginationButtonTextEnabled: {
    color: DESKTOP_COLORS.TABLE.TEXT,
  },
  paginationButtonTextDisabled: {
    color: DESKTOP_COLORS.TABLE.TEXT_SECONDARY,
  },
  emptyStateContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 60,
  },
  emptyStateTitle: {
    fontSize: 18,
    fontWeight: '600',
    marginBottom: 8,
  },
  emptyStateMessage: {
    fontSize: 14,
    textAlign: 'center',
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 60,
  },
  loadingText: {
    marginTop: 12,
    fontSize: 14,
  },
  loadingOverlay: {
    position: 'absolute',
    top: 8,
    right: 16,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: 12,
    padding: 8,
  },
});


